module.exports = __webpack_public_path__ + "static/media/blue-logo.3c8c4b67.png";